import React from 'react';

import RichText from '@/components/ui/RichText/RichText';
import { FooterSection as FooterSectionType } from '@/data/footerData';

import { FooterContactSection } from './FooterContactSection';
import { FooterLinksSection } from './FooterLinksSection';
import { FooterMixedSection } from './FooterMixedSection';

interface FooterSectionProps {
  section: FooterSectionType;
}

export const FooterSection: React.FC<FooterSectionProps> = ({ section }) => {
  return (
    <div className="min-w-0 space-y-6">
      <h3 className="font-mulish mb-6 text-xl font-bold text-white">
        {section.title}
      </h3>

      {section.type === 'contact' && <FooterContactSection section={section} />}
      {section.type === 'links' && <FooterLinksSection section={section} />}
      {section.type === 'mixed' && <FooterMixedSection section={section} />}

      {section.description?.raw && (
        <RichText
          styles={{
            p: 'text-gray-300 text-sm wrap-break-word wrap-anywhere',
          }}
        >
          {section.description.raw}
        </RichText>
      )}
    </div>
  );
};
